import React from 'react';
import { Portal, Icon } from '@app/components';
import {
  Container,
  Backdrop,
  DialogContainer,
  Header,
  Title,
  CloseIcon,
  BackIcon,
  Body,
  Seperator,
} from './dialog-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

type Props = {
  title?: string;
  children?: React.ReactNode;
  onClose?: (e: any) => void;
  showBackButton?: boolean;
  onBackClick?: (e: any) => void;
  size?: string;
  showSeperator?: boolean;
  customStyles?: string;
  isCenter?: boolean;
};

export default function Dialog({
  title,
  children,
  onClose,
  onBackClick,
  showBackButton,
  size,
  showSeperator,
  customStyles,
  isCenter,
}: Props) {
  return (
    <Portal>
      <Container>
        <Backdrop onClick={onClose} />
        <DialogContainer size={size}>
          <Header isCenter={isCenter}>
            {showBackButton && (
              <BackIcon onClick={onBackClick}>
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  onClick={onBackClick}
                  size="lg"
                  style={{ marginRight: '10px' }}
                />
              </BackIcon>
            )}
            <Title customStyles={customStyles}>{title}</Title>
            <CloseIcon onClick={onClose}>
              <Icon name="close" />
            </CloseIcon>
          </Header>
          {showSeperator && <Seperator />}
          {children}
        </DialogContainer>
      </Container>
    </Portal>
  );
}

Dialog.Body = Body;
